export default "__VITE_ASSET__DDv82t35__"